export const calculatePercentageOfObjectCost = (objectCost: number, percent: number): number => {
  return Math.round(objectCost * (percent / 100));
};
